/* V2 only: make room for desktop dropdowns while at the top of the page. */
(() => {
  const setup = () => {
    const page = document.querySelector('.banditos-wear-v2');
    const nav = document.querySelector('.section-header-navigation .header__inline-menu');
    if (!page || !nav || page.dataset.menuSpaceReady) return;
    page.dataset.menuSpaceReady = 'true';
    let frame = 0, until = 0, shift = 0;
    const update = () => {
      frame = 0;
      let next = 0;
      if (window.scrollY <= 4 && nav.getClientRects().length) {
        const base = parseFloat(getComputedStyle(page).getPropertyValue('--wear-base-top')) || 0;
        const closedTop = page.getBoundingClientRect().top + base;
        let bottom = 0;
        nav.querySelectorAll('.menu-lv-1 > .menu-dropdown').forEach(drop => {
          const css = getComputedStyle(drop);
          if (css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) > .01) bottom = Math.max(bottom, drop.getBoundingClientRect().bottom);
        });
        next = bottom ? Math.max(0, Math.ceil(bottom + 16 - closedTop)) : 0;
      }
      if (next !== shift) {
        shift = next;
        page.style.setProperty('--wear-menu-space', shift + 'px');
      }
      if (performance.now() < until) frame = requestAnimationFrame(update);
    };
    const schedule = () => {
      until = performance.now() + 500;
      if (!frame) frame = requestAnimationFrame(update);
    };
    ['pointerover', 'pointerout', 'focusin', 'focusout', 'click'].forEach(type => nav.addEventListener(type, schedule));
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    const observer = new MutationObserver(schedule);
    observer.observe(nav, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-expanded'] });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(page)) return;
      cancelAnimationFrame(frame);
      observer.disconnect();
      ['pointerover', 'pointerout', 'focusin', 'focusout', 'click'].forEach(type => nav.removeEventListener(type, schedule));
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

/* Reserve the measured toolbar height, including any bottom offset. */
(() => {
  const reserveSpace = () => {
    const bar = document.querySelector('.banditos-wear-v2 sticky-add-to-cart');
    if (!bar || bar.dataset.footerSpaceReady) return;
    bar.dataset.footerSpaceReady = 'true';
    const update = () => {
      const css = getComputedStyle(bar);
      const space = css.display === 'none' ? 0 : Math.ceil(bar.getBoundingClientRect().height + (parseFloat(css.bottom) || 0));
      document.body.style.setProperty('--wear-cart-clearance', space + 'px');
    };
    const resize = new ResizeObserver(update);
    resize.observe(bar);
    const mutation = new MutationObserver(update);
    mutation.observe(bar, { attributes: true, attributeFilter: ['style', 'class'] });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reserveSpace, { once: true });
  else reserveSpace();
})();

/* Organize existing accordion copy without changing the mobile presentation. */
(() => {
  const organize = () => {
    const root = document.querySelector('.banditos-wear-v2__details');
    if (!root) return;
    const care = root.querySelector('#tab-care-instructions-mobile');
    if (care && !care.dataset.organized) {
      care.dataset.organized = 'true';
      const grid = document.createElement('div');
      grid.className = 'wear-care-grid';
      [...care.children].filter(el => el.tagName === 'P' && el.querySelector('strong')).forEach(p => {
        p.classList.add('wear-care-item');
        grid.append(p);
      });
      care.append(grid);
    }
    const returns = root.querySelector('#tab-easy-returns-mobile');
    if (returns && !returns.dataset.organized) {
      returns.dataset.organized = 'true';
      const policyTitle = [...returns.querySelectorAll('strong')].find(el => el.textContent.trim() === 'RETURN POLICY:');
      if (policyTitle && !policyTitle.querySelector('a')) {
        const link = document.createElement('a');
        link.href = '/pages/return-refund-cancellation-policy';
        link.textContent = 'View return policy';
        link.style.color = '#64e82e';
        link.style.textDecoration = 'underline';
        policyTitle.after(document.createTextNode(' '), link);
      }
      const walker = document.createTreeWalker(returns, NodeFilter.SHOW_TEXT);
      const emailNodes = [];
      while (walker.nextNode()) {
        if (walker.currentNode.textContent.includes('customer@banditosenergy.shop') &&
            !walker.currentNode.parentElement.closest('a')) emailNodes.push(walker.currentNode);
      }
      emailNodes.forEach(node => {
        const parts = node.textContent.split('customer@banditosenergy.shop');
        const fragment = document.createDocumentFragment();
        parts.forEach((part, index) => {
          if (index) {
            const link = document.createElement('a');
            link.href = 'mailto:customer@banditosenergy.shop';
            link.textContent = 'customer@banditosenergy.shop';
            link.style.color = '#64e82e';
            link.style.textDecoration = 'underline';
            fragment.append(link);
          }
          fragment.append(document.createTextNode(part));
        });
        node.replaceWith(fragment);
      });
      const paragraphs = [...returns.children].filter(el => el.tagName === 'P');
      const steps = document.createElement('div');
      steps.className = 'wear-return-steps';
      [
        ['01', 'Request', 'Contact customer support for help with your return.'],
        ['02', 'Prepare', 'Keep items unused and unwashed, with their original tags attached.'],
        ['03', 'Return', 'Send your return within the stated 14-day return period.']
      ].forEach(([number, title, copy]) => {
        const item = document.createElement('div');
        const label = document.createElement('span');
        label.className = 'wear-return-number'; label.textContent = number;
        const heading = document.createElement('h3'); heading.textContent = title;
        const p = document.createElement('p'); p.textContent = copy;
        item.append(label, heading, p); steps.append(item);
      });
      /* Summary supplements, rather than replaces, the full existing conditions. */
      const intro = paragraphs.find(p => p.textContent.includes('RETURN PERIOD:'));
      const following = intro && intro.nextElementSibling;
      if (following && !following.querySelector('strong')) following.after(steps);
      else returns.prepend(steps);
      const groups = document.createElement('div');
      groups.className = 'wear-return-groups';
      let group;
      let started = false;
      paragraphs.forEach(p => {
        if (p.textContent.includes('RETURN CONDITIONS:')) started = true;
        if (!started) return;
        if (p.querySelector('strong') || !group) {
          group = document.createElement('div'); group.className = 'wear-return-group';
          groups.append(group);
        }
        group.append(p);
      });
      returns.append(groups);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', organize, { once: true });
  else organize();
  document.addEventListener('shopify:section:load', organize);
})();

/* A second close control saves scrolling back through long accordion copy. */
(() => {
  const setupCloseControls = () => {
    document.querySelectorAll('.banditos-wear-v2__details .tab-content').forEach(section => {
      const toggle = section.querySelector('.toggleLink');
      const content = section.querySelector('.toggle-content');
      if (!toggle || !content || !content.textContent.trim() || section.querySelector('.wear-collapse-end')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wear-collapse-end';
      button.textContent = 'Collapse ↑';
      button.setAttribute('aria-label', 'Collapse ' + toggle.textContent.trim());
      button.addEventListener('click', () => {
        if (!toggle.classList.contains('is-open')) return;
        if (button.disabled) return;
        button.disabled = true;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const target = Math.max(0, Math.min(
          window.scrollY + toggle.getBoundingClientRect().top - 100,
          document.documentElement.scrollHeight - window.innerHeight
        ));
        /* Keep the content height stable during scrolling, then close once at the title. */
        window.scrollTo({ top: target, behavior: reduced ? 'instant' : 'smooth' });
        const started = performance.now();
        const finish = () => {
          if (Math.abs(window.scrollY - target) > 2 && performance.now() - started < 1800) {
            requestAnimationFrame(finish);
            return;
          }
          if (toggle.classList.contains('is-open')) toggle.click();
          toggle.focus({ preventScroll: true });
          button.disabled = false;
        };
        requestAnimationFrame(finish);
      });
      section.append(button);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCloseControls, { once: true });
  else setupCloseControls();
  document.addEventListener('shopify:section:load', setupCloseControls);
})();

/* Mobile Wear V2: the existing purchase bar lands below the accordion. */
(() => {
  const setup = () => {
    const page = document.querySelector('.banditos-wear-v2');
    const details = page?.querySelector('.banditos-wear-v2__details');
    const bar = page?.querySelector('sticky-add-to-cart');
    if (!details || !bar || page.dataset.mobileBarReady) return;
    page.dataset.mobileBarReady = 'true';
    const dock = document.createElement('div');
    dock.className = 'wear-mobile-cart-dock';
    dock.setAttribute('aria-hidden', 'true');
    (page.querySelector('[data-product-affiliate-link]') || details).after(dock);
    let frame;
    const update = () => {
      frame = null;
      const mobile = window.innerWidth < 768;
      const height = Math.ceil(bar.getBoundingClientRect().height) || 72;
      if (dock.style.height !== height + 'px') dock.style.height = height + 'px';
      const bottom = dock.getBoundingClientRect().bottom;
      const shift = mobile ? Math.min(0, bottom - window.innerHeight) : 0;
      bar.style.setProperty('--wear-dock-shift', shift + 'px');
      if (mobile) {
        const bounds = bar.getBoundingClientRect();
        const holes = [...bar.querySelectorAll('#show-sticky-product, .sticky-wishlist a')]
          .map(el => el.getBoundingClientRect()).filter(r => r.width && r.height);
        const paths = ['0 0', '100% 0', '100% 100%', '0 100%', '0 0'];
        for (const r of holes) {
          const x = r.left - bounds.left, y = r.top - bounds.top;
          paths.push('0 0', x+'px '+y+'px', (x+r.width)+'px '+y+'px',
            (x+r.width)+'px '+(y+r.height)+'px', x+'px '+(y+r.height)+'px',
            x+'px '+y+'px', '0 0');
        }
        bar.style.setProperty('--wear-cart-surround', 'polygon(evenodd, '+paths.join(', ')+')');
      }
      document.body.classList.toggle('wear-mobile-navigation', mobile && bottom <= window.innerHeight - 80);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    const observer = new ResizeObserver(schedule);
    observer.observe(page);
    observer.observe(bar);
    schedule();
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();

